import { render, staticRenderFns } from "./ReportManagement.vue?vue&type=template&id=6767eb04&scoped=true&"
import script from "./ReportManagement.vue?vue&type=script&lang=js&"
export * from "./ReportManagement.vue?vue&type=script&lang=js&"
import style0 from "./ReportManagement.vue?vue&type=style&index=0&id=6767eb04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6767eb04",
  null
  
)

export default component.exports